import React from 'react'
import { FieldArray } from 'redux-form';
import CreativeSettings from './CreativeSettings';

type Props = {
  record: any
};

const CreativesTab = (props: Props) => (
  <div style={{ paddingTop: 20, maxWidth: 900 }}>
    <FieldArray name='ad_campaign.creatives_attributes' component={CreativeSettings} record={props.record} /><br />
  </div>
);

export default CreativesTab;



// WEBPACK FOOTER //
// ./src/views/Components/Campaigns/Site/Partials/CreativesTab.tsx